export const state = {
  neTravailPas: undefined,
  neTravailPass: [],
  sousNeTravailPas: undefined,
  sousNeTravailPass: []
}